<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>

<div class="table-container">

  <div class="d-flex justify-content-between">
    <div>
      <app-breadcrumb></app-breadcrumb>
    </div>
    <div class="d-flex gap-4 align-items-top">
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        *ngIf="message.isAuditTrailUser" (click)="openAuditTrail()" (keydown.enter)="openAuditTrail()">
        <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Audit Trail</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (keydown.enter)="openReport('Excel')" (click)="openReport('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (keydown.enter)="openReport('Pdf')" (click)="openReport('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
      <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
        (keydown.enter)="refreshForm()" (click)="refreshForm()">
        <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
        <span class="reload_text">Reload</span>
      </div>
    </div>
  </div>

  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>

  <div class="dataEmpty">
    <div class="row" *ngIf="isDmsSettingsDataEmpty">The form presently lacks any content</div>
  </div>

  <div class="form form-content ">
    <div class="row">
      <div class="col-md-4">
        <div><label for="email">Parent Document No. Format</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="dmsSettingsObj.documentNoFormat">
      </div>
      <div class="col-md-4">
        <div><label for="email">Parent Document No. Regeneration</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="dmsSettingsObj.documentNoRegeneration">
      </div>
      <div class="col-md-4">
        <div><label for="email">Document Number No. of Digits</label></div>
        <input class="input-filed-continers" type="number" (keydown)="validateNumberFields($event)"
          [(ngModel)]="dmsSettingsObj.documentNoNoOfDigits">
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div><label for="email">Document No. Format for Associated Documents</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="dmsSettingsObj.documentNoFormatForAssociatedDocs">
      </div>
      <div class="col-md-4">
        <div><label for="email">Document No. Regeneration for Associated Documents</label></div>
        <input class="input-filed-continers" type="text"
          [(ngModel)]="dmsSettingsObj.documentNoRegenerationForAssociatedDocs">
      </div>
      <div class="col-md-4">
        <div><label for="email">Document Number No. of Digits for Associated Documents</label></div>
        <input class="input-filed-continers" type="number" (keydown)="validateNumberFields($event)"
          [(ngModel)]="dmsSettingsObj.documentNoNoOfDigitsForAssociatedDocs">
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div><label for="email">Document No. Format for Amendment Documents</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="dmsSettingsObj.documentNoFormatForAmendmentDocs">
      </div>
      <div class="col-md-4">
        <div><label for="email">Document No. Regeneration for Amendment Documents</label></div>
        <input class="input-filed-continers" type="text"
          [(ngModel)]="dmsSettingsObj.documentNoRegenerationForAmendmentDocs">
      </div>
      <div class="col-md-4">
        <div><label for="email">Document Number No. of Digits for Amendment Documents</label></div>
        <input class="input-filed-continers" type="number" (keydown)="validateNumberFields($event)"
          [(ngModel)]="dmsSettingsObj.documentNoNoOfDigitsForAmendmentDocs">
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div><label for="email">Allowed File Extensions</label></div>
        <mat-select matInput multiple placeholder="Select" #reasonForChange
          [(ngModel)]="dmsSettingsObj.selectedAllowedFileExtns" (closed)="allowedFileExtnsSearchText=''"
          (click)="focusSearch('focusSearch')" (keydown.enter)="focusSearch('focusSearch')">
          <input type="search" id="focusSearch" class="dropdownsearchstyle" [(ngModel)]="allowedFileExtnsSearchText"
            matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="allSelected" (change)="toggleAllSelection('reasonForChange')">Select
              All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item1 of allowedFileExtnList| multiAssessmentSearchPipe :allowedFileExtnsSearchText"
            [value]="item1.valueExp">
            {{ item1.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-4">
        <div><label for="email">PDF Convertable File Extensions</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="dmsSettingsObj.pdfConvertableFileExtns">
      </div>
      <div class="col-md-4">
        <div><label for="email">Viewable File Extensions</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="dmsSettingsObj.viewableFileExtns">
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div><label for="email">Footer Message Format</label></div>
        <div><input class="input-filed-continers" type="text" [(ngModel)]="dmsSettingsObj.footerMessageFormat"
            style="width: 97%;">
          <span id="footerMsg-val-icon" class="field-icon-container" (click)="clickToGetNote()"
            (keydown.enter)="clickToGetNote()" title="Reference Tags" style="cursor: pointer;"></span>
        </div>
      </div>
      <div class="col-md-6">
        <div><label for="email">Water Mark Message Format</label></div>
        <div><input class="input-filed-continers" type="text" [(ngModel)]="dmsSettingsObj.watermarkMessageFormat"
            style="width: 97%;">
          <span id="waterMsg-val-icon" class="field-icon-container" (click)="clickToGetNote()"
            (keydown.enter)="clickToGetNote()" title="Reference Tags" style="cursor: pointer;"></span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div><label for="email">Downloaded Document Name Format</label></div>
        <div><input class="input-filed-continers" type="text" [(ngModel)]="dmsSettingsObj.downloadedDocumentNameFormat"
            style="width: 97%;">
          <span id="documentNameFormat-val-icon" class="field-icon-container" (click)="clickToGetNote()"
            (keydown.enter)="clickToGetNote()" title="Reference Tags" style="cursor: pointer;"></span>
        </div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Statuses Allowed At Trainings</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="dmsSettingsObj.statusesAllowedAtTrainings">
      </div>
      <div class="col-md-3">
        <div><label for="email">Reports Timezone</label></div>
        <mat-select matInput placeholder="Select" [ngClass]="{'odd-item-mat-select': oddTimezone == selectedTimeZone}"
          [(ngModel)]="selectedTimeZone" (closed)="reportsTimezonesearchTxt=''"
          (click)="focusmethod('reportsTimezonefocusSearch')"
          (keydown.enter)="focusmethod('reportsTimezonefocusSearch')">
          <input type="search" id="reportsTimezonefocusSearch" class="dropdownsearchstyle"
            [(ngModel)]="reportsTimezonesearchTxt" matInput placeholder="Search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onReportsTimezoneSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of timeZoneDropdown | assessmentSearch :reportsTimezonesearchTxt"
            (onSelectionChange)="onReportsTimezoneSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>

    </div>
    <div class="row">
      <div class="col-md-3">
        <div><label for="email">Allow To Input Version Manually</label></div>
        <mat-slide-toggle color="primary" [(ngModel)]="dmsSettingsObj.allowToInputVersionManually1">
          <span class="active-inActive-container" *ngIf="dmsSettingsObj.allowToInputVersionManually1==true"
            [ngStyle]="dmsSettingsObj.allowToInputVersionManually1==true?{'color':'green'} : {'color': ''}">Yes</span>
          <span *ngIf="dmsSettingsObj.allowToInputVersionManually1==false"
            [ngStyle]="dmsSettingsObj.allowToInputVersionManually1==false?{'color':'red'} : {'color': ''}">No</span>
        </mat-slide-toggle>
      </div>
      <div class="col-md-3">
        <div><label for="email">Allow To Input Document No. Manually</label></div>
        <mat-slide-toggle color="primary" [(ngModel)]="dmsSettingsObj.allowToInputDocumentNoManually1">
          <span class="active-inActive-container" *ngIf="dmsSettingsObj.allowToInputDocumentNoManually1==true"
            [ngStyle]="dmsSettingsObj.allowToInputDocumentNoManually1==true?{'color':'green'} : {'color': ''}">Yes</span>
          <span *ngIf="dmsSettingsObj.allowToInputDocumentNoManually1==false"
            [ngStyle]="dmsSettingsObj.allowToInputDocumentNoManually1==false?{'color':'red'} : {'color': ''}">No</span>
        </mat-slide-toggle>
      </div>

      <div class="col-md-3">
        <div><label for="email">Enable Edit Online</label></div>
        <mat-slide-toggle color="primary" [(ngModel)]="dmsSettingsObj.onlineEditor">
          <span class="active-inActive-container" *ngIf="dmsSettingsObj.onlineEditor==true"
            [ngStyle]="dmsSettingsObj.onlineEditor==true?{'color':'green'} : {'color': ''}">Yes</span>
          <span *ngIf="dmsSettingsObj.onlineEditor==false"
            [ngStyle]="dmsSettingsObj.onlineEditor==false?{'color':'red'} : {'color': ''}">No</span>
        </mat-slide-toggle>
      </div>

      <div class="col-md-3">
        <div><label for="email">Training Completion Percentage Check for Doc Publish Reqd</label></div>
        <mat-slide-toggle color="primary"
          [(ngModel)]="dmsSettingsObj.trainingCompletionPercentageCheckForDocumentPublishReqd"
          (change)="onPercentageChange()">
          <span class="active-inActive-container"
            *ngIf="dmsSettingsObj.trainingCompletionPercentageCheckForDocumentPublishReqd==true"
            [ngStyle]="dmsSettingsObj.trainingCompletionPercentageCheckForDocumentPublishReqd==true?{'color':'green'} : {'color': ''}">Yes</span>
          <span *ngIf="dmsSettingsObj.trainingCompletionPercentageCheckForDocumentPublishReqd==false"
            [ngStyle]="dmsSettingsObj.trainingCompletionPercentageCheckForDocumentPublishReqd==false?{'color':'red'} : {'color': ''}">No</span>
        </mat-slide-toggle>
      </div>

      <div class="col-md-3" *ngIf="dmsSettingsObj.trainingCompletionPercentageCheckForDocumentPublishReqd">
        <div><label for="trn-com-per-pub"> Minimum Training Completion Percentage</label> <span
            class="mandatory-symbol">*</span></div>
        <input id="trn-com-per-pub" class="input-filed-continers" type="number" (keydown)="validateNumberFields($event)"
          [(ngModel)]="dmsSettingsObj.trainingCompletionPercentageForDocumentPublish" min="1" max="100"
          (input)="onPercentageInput($event)">
      </div>
    </div>
    <br>
    <div class="button-continer formButtons" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="saveDmsSettings(dmsSettingsObj)">
        <i class="fa fa-save"></i> Save
      </button>
    </div>
  </div>

  <ng-template #deleteDmsSettingsPopup>
    <div class="ng-template-container">
      <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
      </div>
      <button class="close close-button" (click)="cancelDeletePopup()" mat-button><i
          class="fa popupClose">&#xf00d;</i></button>
      <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
      </div>

      <div class="col-md-12" style="padding: 2% 0 0 3%;">
        <div><label for="email">Reason For Delete:</label></div>
        <textarea id="deleteReason" type="text" class="input-filed-continers" rows="4" cols="50"
          [(ngModel)]="dmsSettingsObj.deleteReason"></textarea>
        <span id="deleteReason-required-msg">Please provide the reason for delete</span>
      </div>
    </div>

    <div class="button-continer" mat-dialog-actions>
      <button style="margin-left: 1%;" mat-stroked-button class="deleteButton"
        (click)="deleteDmsSettings(dmsSettingsObj)">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeletePopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </ng-template>
  <ng-template #notePopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelNote()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle">Reference Tags</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;">
      <div class="row">
        <div class="col-md-12">
          &lt;DOCUMENT_NO&gt;<br>
          &lt;DOCUMENT_VERSION&gt;<br>
          &lt;DOCUMENT_TYPE_CODE&gt;<br>
          &lt;DOCUMENT_TYPE_NAME&gt;<br>
          &lt;PARENT_DOCUMENT_NO&gt;<br>
          &lt;PARENT_DOCUMENT_VERSION&gt;<br>
          &lt;PARENT_DOCUMENT_TYPE_CODE&gt;<br>
          &lt;PARENT_DOCUMENT_TYPE_NAME&gt;<br>
          &lt;ISSUANCE_TYPE&gt;<br>
          &lt;DOCUMENT_NAME&gt;<br>
          &lt;EFFECTIVE_DATE&gt;<br>
          &lt;EXPIRY_DATE&gt;<br>
          &lt;CURRENT_DATE&gt;<br>
          &lt;USER_NAME&gt;<br>
          &lt;USER_FULLNAME&gt;<br>
          &lt;ISSUED_TO&gt;<br>
          &lt;PRINTS_TAKEN&gt;<br>
          &lt;ISSUANCE_REASON&gt;<br>
          &lt;TEMPLATE_NAME&gt;<br>
          &lt;STATUS&gt;
        </div>
      </div>
    </div>
  </ng-template>
</div>

<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
